import { request } from "./client";

export const authApi = {
  csrf: () => request("/api/auth/csrf/"),

  session: () => request("/api/auth/session/"),

  login: (login, password) =>
    request("/api/auth/login/", {
      method: "POST",
      body: JSON.stringify({ login, password }),
    }),

  signup: (username, email, password1, password2) =>
    request("/api/auth/signup/", {
      method: "POST",
      body: JSON.stringify({ username, email, password1, password2 }),
    }),

  logout: () => request("/api/auth/logout/", { method: "POST" }),

  changePassword: (old_password, new_password1, new_password2) =>
    request("/api/auth/password/change/", {
      method: "POST",
      body: JSON.stringify({ old_password, new_password1, new_password2 }),
    }),

  resetPassword: (email) =>
    request("/api/auth/password/reset/", {
      method: "POST",
      body: JSON.stringify({ email }),
    }),

  resetPasswordConfirm: (uid, token, new_password1, new_password2) =>
    request("/api/auth/password/reset/confirm/", {
      method: "POST",
      body: JSON.stringify({ uid, token, new_password1, new_password2 }),
    }),

  confirmEmail: (key) =>
    request("/api/auth/email/confirm/", {
      method: "POST",
      body: JSON.stringify({ key }),
    }),
};
